import { TOrganization } from 'app/types/entities/TOrganization';

import { OrgInitialsIcon } from './styles/OrgInitialsIcon';

export const OrganizationInitials = ({ org }: { org: TOrganization }) => {
  return <OrgInitialsIcon>{org.name[0]}</OrgInitialsIcon>;
};
